import { FrontendApi, Configuration, Session } from '@ory/client';
import Config from 'src/common/Config';
import { SessionData } from 'src/auth/SessionDataHook';

export const ory = new FrontendApi(
  new Configuration({
    basePath: Config.getAuthBasePath(),
    baseOptions: {
      withCredentials: true,
    },
  }),
);

let cachedSession: Session | null = null;
let inflight: Promise<Session> | null = null;

export async function getSessionOnce(): Promise<SessionData> {
  if (cachedSession) return cachedSession as SessionData;
  if (inflight) return inflight as Promise<SessionData>;

  inflight = (async () => {
    try {
      const res = await ory.toSession();
      cachedSession = res.data as Session;
      return cachedSession;
    } finally {
      inflight = null;
    }
  })();

  return inflight as Promise<SessionData>;
}

export function clearSessionCache() {
  cachedSession = null;
}
